import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { updateEnterprise, type EnterpriseDetailRes, type EnterpriseUpdateParams } from '@/api/org/setting';

/** 与企业详情接口 `EnterpriseDetailRes` 字段一致 */
export type EnterpriseInfo = EnterpriseDetailRes;

export const enterpriseInfoStore = defineStore('enterpriseInfo', () => {
  const enterpriseInfo = ref<EnterpriseInfo>({});
  /** 当前企业 ID 字符串；未加载或无效时为 null */
  const enterpriseId = computed(() => {
    const id = enterpriseInfo.value?.id;
    if (id === undefined || id === null) {
      return null;
    }
    return String(id);
  });
  /** 进入企业相关路由后，异步拉取企业信息的流程是否已结束（成功或失败均置为 true） */
  const enterpriseFinished = ref(false);

  const setEnterpriseFinished = (val: boolean) => {
    enterpriseFinished.value = val;
  };

  /** 合并写入企业信息（仅本地状态） */
  const setEnterpriseInfo = (payload: Partial<EnterpriseInfo>) => {
    enterpriseInfo.value = { ...enterpriseInfo.value, ...payload };
  };

  /** 调用更新接口；成功后把提交字段合并进 store */
  const updateEnterpriseInfo = async (enterpriseId: number | string, data: EnterpriseUpdateParams) => {
    const res = await updateEnterprise(enterpriseId, data);
    if (!res.error) {
      setEnterpriseInfo(data);
    }
    return res;
  };

  return {
    enterpriseInfo,
    enterpriseId,
    enterpriseFinished,
    setEnterpriseFinished,
    setEnterpriseInfo,
    updateEnterpriseInfo
  };
});
